// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { onlyUpdateForPropTypes } from '../../../node_module_clones/recompose';

// Components
import CurrentBoardHeaderTitle from '../header/currentBoardHeader/CurrentBoardHeaderTitle';
import MobileBoardHeaderUtils from './MobileBoardHeaderUtils';

// Styles
import './LegacyMobileBoardHeader.scss';

const LegacyMobileBoardHeader = (props) => {
    const { isCurrentBoardRoot } = props;

    // Hide current board header on root
    if (isCurrentBoardRoot) return null;

    return (
        <div className="LegacyMobileBoardHeader">
            <div className="header-left" />
            <div className="header-center">
                <CurrentBoardHeaderTitle {...props} />
            </div>
            <div className="header-right">
                <MobileBoardHeaderUtils {...props} />
            </div>
        </div>
    );
};

LegacyMobileBoardHeader.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    currentBoard: PropTypes.object.isRequired,
    isCurrentBoardRoot: PropTypes.bool,
    isEditable: PropTypes.bool,
    getDocumentElementSizes: PropTypes.func,
};

export default onlyUpdateForPropTypes(LegacyMobileBoardHeader);
